import { render } from "./RichEditorDialog.vue?vue&type=template&id=74bd0b78&scoped=true&ts=true"
import script from "./RichEditorDialog.vue?vue&type=script&lang=ts"
export * from "./RichEditorDialog.vue?vue&type=script&lang=ts"

import "./RichEditorDialog.vue?vue&type=style&index=0&id=74bd0b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bd0b78"]])

export default __exports__